"use strict";
const { isQuoted, unQuotedString } = require('../../quotedSearchString');
const createSearchStringQuery = searchString => {
    if (!searchString) {
        return { or: [] };
    }
    const shouldPerformExactMatch = isQuoted(searchString);
    const unQuotedSearchString = unQuotedString(searchString);
    if (shouldPerformExactMatch) {
        return {
            or: [
                { customerNumber: unQuotedSearchString },
                { GLN: unQuotedSearchString },
                { organisationNumber: unQuotedSearchString },
            ],
        };
    }
    return {
        or: [
            { name: { iLike: `%${unQuotedSearchString}%` } },
            { deliveryName: { iLike: `%${unQuotedSearchString}%` } },
            { customerNumber: { iLike: `%${unQuotedSearchString}%` } },
            { organisationNumber: { iLike: `%${unQuotedSearchString}%` } },
            { deliveryCity: { iLike: `%${unQuotedSearchString}%` } },
            { deliveryAddress: { iLike: `%${unQuotedSearchString}%` } },
            { emailInvoice: unQuotedSearchString },
        ],
    };
};
module.exports = createSearchStringQuery;
